import * as angular from "angular";
import * as $ from "jquery";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .directive('bringozUpload', bringozUpload);

function bringozUpload($compile, uploadFile) {
  return {
    restrict: 'A',
    link: (scope, elem, attr) => {

      const onUpload = scope.$eval(attr.bringozUpload);
      const onStartUpload = scope.$eval(attr.onStartUpload);
      const onSizeMismatch = scope.$eval(attr.onSizeMismatch);

      let uploadToServer = scope.$eval(attr.uploadToServer);
      const disableUpload = scope.$eval(attr.disableUpload);
      const sizeLimitInKilobyte = scope.$eval(attr.sizeLimit);
      scope.allowedFile = scope.$eval(attr.allowedFiles);

      if (_.isUndefined(uploadToServer)) {
        uploadToServer = true;
      }

      if (!disableUpload) {
        elem.append($compile('<input type="file" accept="{{allowedFile}}">')(scope));
        elem.append('<div class="icon-background"></div>');

        $(elem.find('.icon-background')).click(() => {
          $(elem.find('input[type="file"]')).trigger('click');
        });

        elem.find('input').change(function () {
          if (this.files && !disableUpload) {
            const fileSizeInKilobyte = _.get(this.files, '[0].size', 0) / 1000; // bytes to kilobytes

            if (sizeLimitInKilobyte && (fileSizeInKilobyte > sizeLimitInKilobyte)) {
              if (onSizeMismatch) {
                onSizeMismatch();
              }
              return;
            }

            if (onStartUpload) {
              onStartUpload();
            }
            elem.find('.icon-background').addClass('cover-all');

            if (uploadToServer) {
              uploadFile(this.files[0])
                .then(response => {
                  if (response.data) {
                    response.data.type = 'url';
                  }
                  elem.find('.icon-background').removeClass('cover-all');
                  onUpload(response);
                });
            } else {
              onUpload({data: this.files[0]});
            }
          }
        });
      }
    }
  };
}

